import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import DialogOTP from '../components/Complements/DialogOTP';
import UserPanelInfo from '../components/Complements/UserPanelInfo';
import MessageInfo from '../components/Complements/MessageInfo';
import ServiceSwitchFormReduxForm from '../components/PaymentServiceSwitch/ServiceSwitchForm'
import StandardDialog from '../components/Complements/StandardDialog';
import FormSaveAliasReferenceDialogReduxForm from "../components/Taxes/FormSaveAliasReferenceDialog"
import {
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Typography,
    Avatar,
    Paper,
    useTheme
} from '@material-ui/core';
import { validateIp } from '../functions/store';
import { osName, osVersion, isMobile } from 'react-device-detect';
import { isEmpty, filterArrayEqual } from '../functions/arrays';
import ElectronicRechargesInfoPanel from "../components/Taxes/ElectronicRechargesInfoPanel"
import ElectronicRechargesFormEditFavoriteReduxForm from "../components/ElectronicRecharges/ElectronicRechargesFormEditFavorite"
import VoucherPaymentWeb from '../components/PaymentServiceSwitch/VoucherPaymentWeb';
import { feathersCreateData, feathersFindGET } from "../services"
import { createProcessMeterCode } from './../actions/metersCore'
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { changeStatusUser } from './../actions/codes'
import { getBalanceUser } from "./../actions/balances";
import { encrypt, decrypt, sendMobile } from '../functions/mobile';
import { history } from '../helpers/history';
import { urlVoucher } from '../services/urls';
import moment from 'moment'
import { getAgreementsSwitchServices } from '../actions/agreementsSwitchServices'
import Footer from '../components/Complements/Footer';
import { Add, ArrowBackIos } from '@mui/icons-material';
import { Delete, Edit, FavoriteRounded, Grade } from '@material-ui/icons';

const PaymentServiceSwitchContainer = props => {

    const {
        user,
        auth,
        balances,
        agreementsSwitchServices,
        parameters,
        handleOpenSnack,
        getDeviceData,
        devices,
        updateIpDevice,
        createProcessMeterCode,
        type,
        identityAgreement,
        allAgreementsSwicthServices,
        titleUrl,
        otherServices
    } = props

    // console.log('agreementsSwitchServices', agreementsSwitchServices)
    const theme = useTheme()

    const [accountSelected, setAccountSelected] = useState(balances[0])
    const [dataAll, setDataAll] = useState({
        referenceFavorites: [],
        rateAgreementsCore: []
    })

    const [objectSelectedAll, setObjectSelectedAll] = useState({
        agreementSelected: {
            AgreementForm: [],
            category: "",
            hasIndividualRate: 1,
            hasBilling: 1,
            name: "",
            rate: "0",
            uuid: "",
            identity: "",
            nameIdentity: ""
        },
        referenceFavoriteSelected: {},
        responseTransaction: {},
        responseConsultDebt: {
            uuidConsultDebt: "",
            customer: "",
            identification: "",
            agreement: "",
            reference: "",
            headings: []
        },
        rateAgreementsCoreSelected: {
            secuencial: 0,
            nombre: "",
            comision: 0
        },
        payment: {
            concept: ""
        }
    })

    const [listDetail, setListDetail] = useState([])

    //Dialogos

    const [dataDialogListFavorites, setDataDialogListFavorites] = useState({
        title: "",
        content: <div></div>,
        show: false
    })

    const [showDialogFormAddFavorites, setShowDialogFormAddFavorites] = useState(false)
    const [openDialogAddFavorites, setOpenDialogAddFavorites] = useState(false)
    const [isReferenceFavorites, setIsReferenceFavorites] = useState(false)

    const [OTP, setOTP] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })

    // Rederer
    const [showMenuOptions, setShowMenuOptions] = useState(true)
    const [showVoucher, setShowVoucher] = useState(false)
    const [showDetailDebt, setShowDetailDebt] = useState(false)


    //Loading
    const [loading, setLoading] = useState(false)

    const mount = () => {
        const unmount = () => {
            if (allAgreementsSwicthServices.length === 0) {
                handleGetAllAgreementsSwicthServices()
            }
            handleGetReferenceFavorites()
            setObjectSelectedAll({
                ...objectSelectedAll,
                agreementSelected: {
                    AgreementForm: [],
                    category: "",
                    hasIndividualRate: 1,
                    name: "",
                    rate: "0",
                    uuid: "",
                    identity: "",
                    nameIdentity: ""
                }
            })
            setShowMenuOptions(true)
            setShowVoucher(false)
            setShowDetailDebt(false)
            //setContAttempts(0)
        }
        return unmount()
    }

    useEffect(mount, [type])

    // PETICIONES AL SERVIDOR

    const handleGetAllAgreementsSwicthServices = async () => {

        setLoading(true)

        try {

            await props.getAgreementsSwitchServices().then(res => {
                setLoading(false)
            }).catch(error => {
                setLoading(false)
            })


        } catch (error) {
            //console.log(error)
            setLoading(false)
        }
    }

    const handleGetReferenceFavorites = async () => {

        setLoading(true)

        try {

            let object_query = {}

            if (identityAgreement.length > 0) {
                object_query = {
                    agreement: identityAgreement,
                    state: 1
                }
            } else {
                object_query = {
                    categoryAgreement: type,
                    state: 1
                }
            }

            const data_favorite_reference = await feathersFindGET("favorite-reference", object_query)()

            //console.log(data_favorite_reference)

            setDataAll({
                rateAgreementsCore: [],
                referenceFavorites: data_favorite_reference
            })

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener los números de celular favoritos.", "error")

        }
    }

    //Default

    const handleChangeSelectedAgreement = (agreementSelected) => {

        try {

            setLoading(true)

            setObjectSelectedAll({
                ...objectSelectedAll,
                agreementSelected
            })

            const { nameIdentity } = agreementSelected;

            const response_filter_agreement_rate = otherServices.filter((item) => item.nombre === nameIdentity);

            // console.log('response_filter_agreement_rate', response_filter_agreement_rate)

            setObjectSelectedAll({
                ...objectSelectedAll,
                agreementSelected,
                rateAgreementsCoreSelected: response_filter_agreement_rate[0]
            })

            setLoading(false)

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al seleccionar el convenio", "error")
            setLoading(false)
        }

    }

    //Referencias Favoritas

    const renderListReferenceFavorites = () => {

        return <List>
            {
                (dataAll.referenceFavorites.length > 0) ? dataAll.referenceFavorites.map(item => {
                    return <div key={item.id}>
                        <ListItem button onClick={() => handleSelectedReferenceFavorites(item)}>
                            <ListItemAvatar>
                                {/* <img src={process.env.PUBLIC_URL + '/images/favorito.png'} alt="Logo" style={{ width: '50px' }} /> */}
                                <Grade color='primary' />
                            </ListItemAvatar>
                            <ListItemText primary={item.name} secondary={renderDetailReferenceFavorites(item)} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" style={{ padding: '5px', marginRight: '10px' }} aria-label="edit" onClick={() => editReferenceFavorites(item)} >
                                    {/* <img src={process.env.PUBLIC_URL + '/images/editar.png'} alt="Logo" style={{ width: '50px' }} /> */}
                                    <Edit color='primary'/>
                                </IconButton>
                                <IconButton edge="end" style={{ padding: '5px' }} aria-label="delete" onClick={() => deleteReferenceFavorites(item)} >
                                    {/* <img src={process.env.PUBLIC_URL + '/images/borrar.png'} alt="Logo" style={{ width: '50px' }} /> */}
                                    <Delete style={{ color: 'red' }} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </div>
                }) : <ListItem >
                    <ListItemText primary={"No se han encontrado referencias favoritas."} />
                </ListItem>
            }
        </List>
    }

    const renderDetailReferenceFavorites = (item) => {

        return <Typography >
            <b>{`Referencia: `}</b>{`${item.reference} `}
            <br />
            <b>{`Institución: `}</b>{`${item.institution} `}
        </Typography>
    }

    const handleSelectedReferenceFavorites = async (itemFavoriteSelected) => {

        try {
            setLoading(true)

            setDataDialogListFavorites({
                ...dataDialogListFavorites,
                show: false
            })

            const { agreement, reference } = itemFavoriteSelected

            const response_filter_agreement = agreementsSwitchServices.filter((ag) => ag.identity === agreement)

            // console.log(response_filter_agreement)

            if (response_filter_agreement.length > 0) {

                const sendData = encrypt(JSON.stringify({
                    access: "CONSULT_DEBT",
                    channel: "WEB",
                    body: {
                        agreement: response_filter_agreement[0].uuid,
                        reference
                    }
                }))

                const response_consult_debt = await feathersCreateData("switch-services", {
                    sendData
                })()

                const { responseData } = response_consult_debt

                const response_consult_debt_decrypt = JSON.parse(decrypt(responseData))

                //console.log(response_consult_debt)

                const { error, response } = response_consult_debt_decrypt

                if (error === false) {

                    const { headings } = response

                    if (headings.length > 0) {

                        setIsReferenceFavorites(true)

                        setShowDetailDebt(true)
                        setShowMenuOptions(false)

                        setObjectSelectedAll({
                            ...objectSelectedAll,
                            responseConsultDebt: response,
                            agreementSelected: {
                                AgreementForm: response_filter_agreement[0].AgreementForm,
                                category: response_filter_agreement[0].category,
                                hasIndividualRate: response_filter_agreement[0].hasIndividualRate,
                                identity: response_filter_agreement[0].identity,
                                name: response_filter_agreement[0].name,
                                nameIdentity: response_filter_agreement[0].nameIdentity,
                                rate: response_filter_agreement[0].rate,
                                uuid: response_filter_agreement[0].uuid
                            }
                        })

                        handleProccessViewDetailConsultDebt(response)

                    } else {
                        handleOpenSnack("No se han encontrado deudas.", "info")
                    }

                } else {
                    handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
                }
                setLoading(false)
            } else {

                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio registrado.", "info")
            }

        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
        }
    }

    const deleteReferenceFavorites = async (row) => {

        try {

            setLoading(true)

            const sendData = encrypt(JSON.stringify({
                action: "UPDATE",
                dataFavoriteReference: {
                    id: row.id,
                    state: 0
                }
            }))

            await feathersCreateData("procces-favorite-reference", { sendData })()

            const { referenceFavorites } = dataAll

            let auxReferenceFavorites = referenceFavorites

            let index = referenceFavorites.findIndex((item) => item.id === row.id)

            auxReferenceFavorites.splice(index, 1)

            setDataAll({
                ...dataAll,
                referenceFavorites: auxReferenceFavorites
            })

            setDataDialogListFavorites({
                ...dataDialogListFavorites,
                content: renderListReferenceFavorites()
            })

            handleOpenSnack("Se ha eliminado correctamente.", "success")

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al eliminar un favorito.", "error")

        }
    }

    //Editar Referencia Favorita

    const editReferenceFavorites = (item) => {
        // console.log(item)

        try {

            setObjectSelectedAll({
                ...objectSelectedAll,
                referenceFavoriteSelected: item
            })

            localStorage.setItem("referenceFavorites", JSON.stringify(item))

            setLoading(true)

            const response_filter_agreement = agreementsSwitchServices.filter((agree) => agree.identity === item.agreement)

            // console.log(response_filter_agreement)

            if (response_filter_agreement.length > 0) {

                let titleLabel = (response_filter_agreement[0].AgreementForm.length > 0) ? response_filter_agreement[0].AgreementForm[0].label : "Referencia"

                localStorage.setItem("agreementSelectedEditFavorites", JSON.stringify(response_filter_agreement[0]))

                setDataDialogListFavorites({
                    show: true,
                    content: renderFormEditFavorites(response_filter_agreement[0], item.name, item.reference, titleLabel),
                    title: "Editar Favoritos"
                })

                setLoading(false)

            } else {
                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio.", "info")
            }

        } catch (error) {
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener información de la referencia favorita.", "error")
        }
    }

    const handleUpdatedFavorites = async (valuesFormEditReferenceFavorites) => {

        setLoading(true)

        try {

            let flag_validation_repeat_favorite = false

            const { alias, reference } = valuesFormEditReferenceFavorites

            const agreement = JSON.parse(localStorage.getItem("agreementSelectedEditFavorites"))

            const referenceFavorites = JSON.parse(localStorage.getItem("referenceFavorites"))

            const response_filter_agreement = agreementsSwitchServices.filter((row) => row.name === agreement.name)

            const response_filter_data_reference_favorite = dataAll.referenceFavorites.filter((item) => item.id === referenceFavorites.id)

            if (response_filter_agreement.length > 0) {

                if (alias.toUpperCase() !== response_filter_data_reference_favorite[0].name) {

                    const response_filter_favorite_by_alias = dataAll.referenceFavorites.filter((row) => row.name === alias.toUpperCase())

                    if (response_filter_favorite_by_alias.length > 0) {
                        flag_validation_repeat_favorite = true
                    } else {
                        flag_validation_repeat_favorite = false
                    }

                } else {
                    flag_validation_repeat_favorite = false
                }

                if (flag_validation_repeat_favorite === false) {

                    if (reference !== response_filter_data_reference_favorite[0].reference) {

                        const response_filter_favorite_by_reference = dataAll.referenceFavorites.filter((row) => row.reference === reference)

                        if (response_filter_favorite_by_reference.length > 0) {
                            flag_validation_repeat_favorite = true
                        } else {
                            flag_validation_repeat_favorite = false
                        }
                    } else {
                        flag_validation_repeat_favorite = false
                    }

                    if (flag_validation_repeat_favorite === false) {

                        const sendData = encrypt(JSON.stringify({
                            action: "UPDATE",
                            dataFavoriteReference: {
                                id: referenceFavorites.id,
                                name: alias.toUpperCase(),
                                reference,
                                agreement: response_filter_agreement[0].identity,
                                institution: agreement.name
                            }
                        }))
                        await feathersCreateData("procces-favorite-reference", { sendData })()
                        handleGetReferenceFavorites()
                        setDataDialogListFavorites({
                            ...dataDialogListFavorites,
                            show: false
                        })
                        handleOpenSnack("Se ha actualizado correctamente.", "success")
                        setLoading(false)
                    } else {
                        setLoading(false)
                        handleOpenSnack("La referencia ya existen.", "info")
                    }
                } else {
                    setLoading(false)
                    handleOpenSnack("El alias ya existen.", "info")
                }

            } else {
                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio seleccionado.", "info")
            }

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al actualizar la referencia favorita.", "error")
            setLoading(false)

        }
    }

    const handleChangeAgreementEditFavorite = (agreementSelectedEditReferenceFavorites) => {

        try {
            localStorage.setItem("agreementSelectedEditFavorites", JSON.stringify(agreementSelectedEditReferenceFavorites))
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al seleccionar el convenio.", "error")
        }
    }

    const handleCancelFormEditFavorites = () => {
        try {

            setDataDialogListFavorites({
                show: false,
                content: renderListReferenceFavorites(),
                title: "Lista de Favoritos"
            })

        } catch (error) {
            handleOpenSnack("Ha ocurrido un error. Por favor vuelva a intentar.", "error")
        }
    }

    const renderFormEditFavorites = (agreement, alias, reference, labelReference) => {
        return <div><ElectronicRechargesFormEditFavoriteReduxForm
            onSubmit={handleUpdatedFavorites}
            agreements={agreementsSwitchServices}
            handleChangeAgreementEditFavorite={handleChangeAgreementEditFavorite}
            onCancelAction={handleCancelFormEditFavorites}
            initialValues={{
                agreement,
                alias,
                reference
            }}
            titleLabelReference={labelReference}
            titleLabelAgreement={"Seleccione un Convenio"}
        /></div>
    }

    //Dialogos

    const handleCloseDialogListFavorites = () => {
        setDataDialogListFavorites({
            ...dataDialogListFavorites,
            show: false
        })
    }

    // Agregar a favoritos

    const handleCloseDialogAddFavorites = () => {
        setOpenDialogAddFavorites(false)
        setShowDialogFormAddFavorites(false)
    }

    const handleSubmitAddFavorites = async (values) => {
        //console.log(values)

        try {

            setLoading(true);

            const { alias } = values

            const response_filter_reference_favorites = dataAll.referenceFavorites.filter((row) => row.name === alias.toUpperCase())

            if (response_filter_reference_favorites.length > 0) {
                handleOpenSnack("El alias ya existe.", "info")
            } else {

                const sendData = encrypt(JSON.stringify({
                    action: "CREATE",
                    dataFavoriteReference: {
                        reference: objectSelectedAll.responseConsultDebt.reference,
                        name: alias.toUpperCase(),
                        agreement: objectSelectedAll.agreementSelected.identity,
                        institution: objectSelectedAll.agreementSelected.name,
                        additionalInformation: "",
                        categoryAgreement: type,
                        state: 1,
                        user: auth.id
                    }
                }))

                await feathersCreateData("procces-favorite-reference", {
                    sendData
                })()
                handleGetReferenceFavorites()
                setOpenDialogAddFavorites(false)
                setShowDialogFormAddFavorites(false)
                setIsReferenceFavorites(true)

                handleOpenSnack('Se ha almacenado exitosamente a favoritos.', 'success')

            }

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack('No se ha podido registrar a favoritos. Por favor intente nuevamente.', 'error')

        }
    }

    const handleSaveFavorites = () => {
        setOpenDialogAddFavorites(true)
        setShowDialogFormAddFavorites(true)
    }

    //OTP

    const handleUpdatedBalances = async () => {
        await props.getBalanceUser({ NumeroCliente: user.numeroCliente, SecuencialEmpresa: 1, EstaActiva: true }).then(res => {
            //console.log(res)
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.PRODUCTBANKID === accountSelected.PRODUCTBANKID) ? true : false;

            })

            setAccountSelected(getdataaccountselected[0])

        })
            .catch(err => {
                //console.log(' error al obtener balances ', err)
            })
    }

    const handleOTPCompare = async ({ data }) => {

        try {

            setLoading(true)
            setOTP({
                ...OTP,
                openOtp: false
            })

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 29,
                inputOtp: data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            // console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type: typeMessage, viewDialogOtp, authorizeTransactions } = responseValidateCode;

            if (error === false) {

                const array_headings = []

                array_headings.push(objectSelectedAll.responseConsultDebt.headings[0])

                //console.log(objectSelectedAll)

                const sendData = encrypt(JSON.stringify({
                    access: "PAYMENT",
                    channel: "WEB",
                    body: {
                        NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                        montoPagar: objectSelectedAll.responseConsultDebt.headings[0].valueWithCommission,
                        otp: data,
                        headings: array_headings,
                        agreementName: objectSelectedAll.agreementSelected.name,
                        reference: objectSelectedAll.responseConsultDebt.reference,
                        agreement: objectSelectedAll.agreementSelected.uuid,
                        concept: objectSelectedAll.payment.concept,
                        billingData: {
                            identification: auth.identification,
                            name: auth.customer.first_name + " " + auth.customer.second_name + " " + auth.customer.surname + " " + auth.customer.second_surname,
                            cellphone: (auth.cellphone !== null) ? auth.cellphone : "9999999999",
                            email: (auth.email !== "") ? auth.email : "na@gmail.com",
                            address: "Sin dirección"
                        },
                        uuidConsultDebt: objectSelectedAll.responseConsultDebt.uuidConsultDebt,
                        IdentificacionDeudor: objectSelectedAll.responseConsultDebt.identification,
                        NombreDeudor: objectSelectedAll.responseConsultDebt.customer,

                        codeOtherService: objectSelectedAll.agreementSelected.uuid,
                        //codeOtherService: objectSelectedAll.rateAgreementsCoreSelected.secuencial,
                        //SecuencialCuenta : accountSelected.Secuencial,

                        //concept : objectSelectedAll.payment.concept,


                        //NumeroCliente : user.NumeroCliente,
                        //headings : array_headings,

                        //reference : objectSelectedAll.responseConsultDebt.reference
                    },
                    device: {
                        ip,
                        mac,
                        device
                    },
                    dataDevice: {
                       ip,
                        mac,
                        device
                    },
                    type: 29
                }))

                if (authorizeTransactions) {
                  const authorizeTransactionsResp = await feathersCreateData('process-authorize-transaction', {
                    payload: sendData,
                    service: 'REGISTER_TRANSACTION'
                  })()
                    setLoading(false)
                    // console.log(sendData);
                    setOTP({
                      id: '',
                      openOtp: false,
                      type: '',
                      code: ''
                    })
                      handleBackDetailDebt()
                      handleOpenSnack(authorizeTransactionsResp.message, authorizeTransactionsResp.type)
                      return
                }

                const response_payment = await feathersCreateData("switch-services", {
                    sendData
                })()

                // console.log(response_payment)

                const { responseData } = response_payment

                const response_payment_decrypt = JSON.parse(decrypt(responseData))

                const { error, response, errors } = response_payment_decrypt;

                if (error === false) {

                    setOTP({
                        ...OTP,
                        openOtp: false
                    })
                    handleUpdatedBalances()
                    setObjectSelectedAll({
                        ...objectSelectedAll,
                        responseTransaction: response
                    })
                    setShowVoucher(true)
                    handleOpenSnack('Se ha realizado exitosamente el pago.', 'success')

                } else {

                    setOTP({
                        ...OTP,
                        openOtp: false
                    })
                    handleOpenSnack((errors.length > 0) ? errors[0].message : "Ha ocurrido un error al realizar el pago.", "error")
                }

                setLoading(false)

            } else {

                if (viewDialogOtp === false) {
                    setOTP({ ...OTP, openOtp: false })
                } else {
                    setOTP({
                        ...OTP,
                        openOtp: true
                    })
                }
                setLoading(false)
                handleOpenSnack(message, typeMessage);

            }

        } catch (error) {
            // console.log(error);
            setLoading(false)
            setOTP({
                ...OTP,
                openOtp: false
            })
            handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")

        }
    }

    const handleGenerateOtp = async (type) => {

        setLoading(true)

        try {

            const { ip } = devices

            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)

            let deviceData = `${osName} ${osVersion}`
            let mac = 'NAVEGADOR'

            if (!isEmpty(devices)) {
                const { device, ip: ipDevice, mac: macDevice } = devices
                deviceData = device;
                ipSend = ipDevice;
                mac = macDevice;
            }

            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type, deviceData, ip: ipSend, mac
            }))

            createProcessMeterCode({ sendData })
                .then(({ payload }) => {
                    //const { result, data } = payload
                    const responseDataDecrypt = JSON.parse(decrypt(payload.responseData ? payload.responseData : payload))
                    setLoading(false)
                    if (responseDataDecrypt.error) {
                      handleOpenSnack(responseDataDecrypt.alert || responseDataDecrypt.message, responseDataDecrypt.type || 'error')
                      return
                    }
                    setOTP({
                        ...OTP,
                        //id: data.sequence,
                        //code: result,
                        type,
                        openOtp: true
                    })
                    // setLoading(false)
                }).catch(err => {
                    // console.log(err)
                    // setLoading(false)
                    handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')
                })

        } catch (error) {
            // console.log(error);
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    const handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (valueinput.target.value.toString().length === tokenLength) {
            handleOTPCompare({ data: valueinput.target.value.toString() });
        }
    }

    //Consulta de Deuda

    const handleValidatePatternReference = (AgreementForm, valueReference) => {

        if (AgreementForm.length > 0) {

            let statusValidation = true

            let validatePattern = new RegExp(AgreementForm[0].pattern);

            if (validatePattern.test(valueReference) === false) {
                statusValidation = false
                handleOpenSnack(AgreementForm[0].messageValidationPattern, "error")
            } else {
                if (valueReference.length > parseInt(AgreementForm[0].maxLength)) {
                    statusValidation = false
                    handleOpenSnack(`Debe tener ${AgreementForm[0].maxLength} carácteres o menos.`, "error")
                } else {
                    statusValidation = true
                }
            }

            //console.log(statusValidation)

            return statusValidation

        } else {
            return true
        }
    }

    const handleSubmitConsultDebt = async (valueFormConsultDebt) => {
        //console.log(valueFormConsultDebt)

        try {

            setLoading(true)

            const { reference } = valueFormConsultDebt


            if (objectSelectedAll.agreementSelected.uuid.length > 0) {

                //Validar por el pattern

                if (handleValidatePatternReference(objectSelectedAll.agreementSelected.AgreementForm, reference) === true) {

                    const response_filter_reference = dataAll.referenceFavorites.filter((item) => item.reference === reference)

                    if (response_filter_reference.length > 0) {
                        setIsReferenceFavorites(true)
                    } else {
                        setIsReferenceFavorites(false)
                    }

                    const sendData = encrypt(JSON.stringify({
                        access: "CONSULT_DEBT",
                        channel: "WEB",
                        body: {
                            agreement: objectSelectedAll.agreementSelected.uuid,
                            reference
                        }
                    }))

                    const response_consult_debt = await feathersCreateData("switch-services", {
                        sendData
                    })()

                    const { responseData } = response_consult_debt

                    const response_consult_debt_decrypt = JSON.parse(decrypt(responseData))

                    //console.log(response_consult_debt)

                    const { error, response } = response_consult_debt_decrypt

                    if (error === false) {

                        const { headings } = response

                        if (headings.length > 0) {

                            setObjectSelectedAll({
                                ...objectSelectedAll,
                                responseConsultDebt: response
                            })

                            handleProccessViewDetailConsultDebt(response)

                        } else {
                            handleOpenSnack("No se han encontrado deudas.", "info")
                        }

                    } else {
                        handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
                    }
                    setLoading(false)

                }

            } else {
                handleOpenSnack("Debe seleccionar un convenio.", "info")
            }

            setLoading(false)
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
        }
    }

    const handleCancelActionConsultDebt = () => {
        setShowMenuOptions(true)
        setShowVoucher(false)
        setShowDetailDebt(false)
    }

    const handleProccessViewDetailConsultDebt = (dataResponse) => {

        try {

            setListDetail([
                {
                    id: '1',
                    title: dataResponse.customer,
                    data: dataResponse.identification,
                    icon: 'person',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '2',
                    title: (objectSelectedAll.agreementSelected.AgreementForm.length > 0) ? objectSelectedAll.agreementSelected.AgreementForm[0].label : "Referencia",
                    data: dataResponse.reference,
                    icon: 'badge',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '3',
                    title: "Rubro",
                    data: dataResponse.headings[0].description,
                    icon: 'info',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '4',
                    title: "Intitución",
                    data: dataResponse.agreement,
                    icon: 'business',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '5',
                    title: "Valor",
                    data: dataResponse.headings[0].amount,
                    icon: 'attach_money',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '6',
                    title: "Comisión",
                    data: dataResponse.headings[0].rate,
                    icon: 'attach_money',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '7',
                    title: 'Valor a pagar',
                    data: dataResponse.headings[0].valueWithCommission,
                    icon: 'monetization_on',
                    pstyle: {
                        color: '#b98919',
                        fontWeight: 'bold',
                        fontSize: '1.05rem'
                    },
                    sstyle: {
                        color: '#b98919',
                        fontWeight: 'bold',
                        fontSize: '1rem'
                    }
                },
            ])

            setShowDetailDebt(true)

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al mostrar el detalle de la deuda", "error")
        }
    }

    //Pago

    const handleSubmitPayment = (valueFormConsultDebt) => {

        try {

            setLoading(true)

            const resultFilterValueMinBalance = parameters.filter((param) => param.code === "MINIMUM_BALANCE")
            const valueMinBalance = (resultFilterValueMinBalance.length > 0) ? resultFilterValueMinBalance[0].value : "2"

            let description = valueFormConsultDebt.payments_description_input || 'Pago de servicios';
            description = description.toUpperCase();

            setObjectSelectedAll({
                ...objectSelectedAll,
                payment: {
                    concept: description.toUpperCase()
                }
            })

            //console.log(accountSelected.SaldoCuenta)

            if (parseFloat(objectSelectedAll.responseConsultDebt.headings[0].valueWithCommission) > parseFloat(accountSelected.SALDOINT)) {

                setLoading(false)
                handleOpenSnack('El valor excede el saldo disponible.', 'error')

            } else {

                if ((parseFloat(accountSelected.SALDOINT) - parseFloat(objectSelectedAll.responseConsultDebt.headings[0].valueWithCommission)) < parseFloat(valueMinBalance)) {

                    setLoading(false)
                    handleOpenSnack('El valor del saldo mínimo no debe ser menor a $ ' + valueMinBalance, 'error')

                } else {

                    setLoading(false)
                    handleAcceptDialogConfirmationTransaction(description.toUpperCase())

                }

            }

        } catch (error) {
            console.log(error);
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    const handleBackDetailDebt = () => {
        setShowDetailDebt(false)
        setShowMenuOptions(false)
        setShowVoucher(false)
    }
    const handleAcceptDialogConfirmationTransaction = () => {
        handleGenerateOtp(29)
    }

    const handleMaskNumberAccount = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }
    }
    //VOUCHER

    const handleDownloadVoucher = () => {
        window.open(urlVoucher + objectSelectedAll.responseTransaction.nombreArchivoComprobante + ".pdf", '_blank');
    }

    //Renderizar Vistas

    const renderProcess = () => {
        return (showDetailDebt === false) ? <ServiceSwitchFormReduxForm
            onSubmit={handleSubmitConsultDebt}
            agreementsSelected={objectSelectedAll.agreementSelected}
            setAgreementsSelected={handleChangeSelectedAgreement}
            agreements={agreementsSwitchServices}
            onCancelAction={handleCancelActionConsultDebt}
            titleSelectAgreement={"Seleccione un convenio"}
            titleLabelReference={(objectSelectedAll.agreementSelected.AgreementForm.length > 0) ? objectSelectedAll.agreementSelected.AgreementForm[0].label : "Referencia"}
        /> : renderDetailConsultDebt()
    }

    const renderDetailConsultDebt = () => {
        return <ElectronicRechargesInfoPanel
            listDetail={listDetail}
            processPayment={handleSubmitPayment}
            getBack={handleBackDetailDebt}
            isFavorites={isReferenceFavorites}
            saveFavorites={handleSaveFavorites}
        />
    }

    const renderVoucher = () => {
        // console.log('objectSelectedAll.responseTransaction', objectSelectedAll.responseTransaction)
        return <VoucherPaymentWeb
            monto={parseFloat(objectSelectedAll.responseTransaction.valor).toFixed(2)}
            titleheader={"TRANSACCIÓN EXITOSA"}
            title={"PAGO DE SERVICIOS"}
            titleone={"DATOS SERVICIO"}
            typesizegrid={6}
            handleResetPayment={handleCancelActionConsultDebt}
            viewVoucher={false}
            databodyone={[
                {
                    title: "Servicio",
                    value: objectSelectedAll.responseTransaction.servicio,
                    order: 1
                },
                {
                    title: "Institución",
                    value: objectSelectedAll.responseTransaction.nombreInstitucion,
                    order: 2
                },
                {
                    title: "Referencia",
                    value: objectSelectedAll.responseTransaction.referencia,
                    order: 3
                },
                {
                    title: "Identificación",
                    value: objectSelectedAll.responseTransaction.identificacionDeudor,
                    order: 4
                },
                {
                    title: "Deudor",
                    value: objectSelectedAll.responseTransaction.nombreDeudor,
                    order: 5
                },
                {
                    title: "Rubro",
                    value: objectSelectedAll.responseTransaction.rubros,
                    order: 6
                },
                {
                    title: "Monto",
                    value: "$ " + parseFloat(objectSelectedAll.responseTransaction.monto).toFixed(2),
                    order: 8
                },
                {
                    title: "Factura",
                    value: objectSelectedAll.responseTransaction.factura,
                    order: 9
                },
                {
                    title: "Comisión",
                    value: "$ " + parseFloat(objectSelectedAll.responseTransaction.comision).toFixed(2),
                    order: 10
                }
            ]}
            titletwo={"DATOS EMISOR"}
            databodytwo={[
                {
                    title: "# Socio",
                    value: objectSelectedAll.responseTransaction.numeroCliente,
                    order: 1
                },
                {
                    title: "Socio",
                    value: objectSelectedAll.responseTransaction.nombreCliente,
                    order: 2
                },
                {
                    title: "Número de cuenta",
                    value: handleMaskNumberAccount(objectSelectedAll.responseTransaction.numeroCuentaOrigen),
                    order: 3
                },
                {
                    title: "Fecha",
                    value: moment(objectSelectedAll.responseTransaction.fecha).format("YYYY-MM-DD"),
                    order: 4
                },
                {
                    title: "Concepto",
                    value: objectSelectedAll.responseTransaction.concepto,
                    order: 5
                },
                {
                    title: "Dcto. de transacción",
                    value: objectSelectedAll.responseTransaction.elements[4].attributes.value,
                    order: 6
                },
                {
                    title: "Dispositivo",
                    value: objectSelectedAll.responseTransaction.dispositivo,
                    order: 7
                }
            ]}
            handleDownloadVoucher={handleDownloadVoucher}
            handleDownloadDevice={() => {
                try {
                    let send = {
                        type: 'action',
                        action: 'export_voucher',
                        data: urlVoucher + objectSelectedAll.responseTransaction.nombreArchivoComprobante + ".pdf",
                        nameFile: objectSelectedAll.responseTransaction.nombreArchivoComprobante,
                        extension: 'pdf',
                        messageSend: 'PAGO DE ' + type
                    }
                    sendMobile(JSON.stringify(send))
                } catch (error) {
                    //console.log(error)
                }
            }}
        />
    }

    const renderMenu = () => {

        return <List style={{
            flexGrow: 1,
            padding: "20px",
            // border: '2px solid #BEBCC0',
            backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',

            borderRadius: "8px",
            // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
        }}>
            {/* <StandardList
            dataList={optionsList}
            primary={'primary'}
            secondary={'secondary'}
            selectItem={handleSelectedItemMenu}
            />*/}
            <ListItem button id={"payments_select_favourite"}
                onClick={() => {
                    setDataDialogListFavorites({
                        content: renderListReferenceFavorites(),
                        show: true,
                        title: "Lista de Favoritos"
                    })
                }
                }
            >
                <ListItemAvatar>
                    <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                        <FavoriteRounded />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Seleccione referencia favorita"} secondary="" />
            </ListItem>
            <ListItem button id={"payments_add_reference"}
                onClick={() => {
                    setShowMenuOptions(false)
                    setShowVoucher(false)
                }}
            >
                <ListItemAvatar>
                    <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                        <Add />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Agregar Nueva Referencia"} secondary="" />
            </ListItem>
        </List>
    }

    const renderBody = () => {

        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <Paper elevation={0} container style={{
                    padding: isMobile ? 8 : 20,
                    // border: '2px solid #BEBCC0',

                    borderRadius: "8px",
                    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
                }}>
                    {/* <Grid xs={12} >
                        <Title><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Pago de Servicios</Title>
                    </Grid> */}
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        <UserPanelInfoMobile
                            tittle={"PAGO DE SERVICIOS - " + titleUrl}
                            user={user}
                            balances={balances}
                            accountSelected={accountSelected}
                            changeAccount={setAccountSelected}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} xl={6}>
                        {(showMenuOptions === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}
                    </Grid>
                </Paper>
            }
        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <Paper elevation={0} style={{
                    display: 'flex',
                    padding: "20px",
                    // border: '2px solid #BEBCC0',

                    borderRadius: "16px",
                    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
                }}>
                    <Grid container spacing={3}>
                        <Grid xs={12}>
                            <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Pago de Servicios</Typography>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <UserPanelInfo
                                tittle={titleUrl}
                                user={user}
                                balances={balances}
                                accountSelected={accountSelected}
                                changeAccount={setAccountSelected}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            {(showMenuOptions === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}
                        </Grid>
                    </Grid>

                </Paper>

            }
        }
    }

    const timeLifeTokenObj = parameters.filter((param) => param.code === "TIME_LIFE_TOKEN")
    const timeLifeToken = parseInt(timeLifeTokenObj[0].value)

    return (

        <div >
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <Footer />
            <StandardDialog
                open={dataDialogListFavorites.show}
                title={dataDialogListFavorites.title}
                handleClose={handleCloseDialogListFavorites}
                children={dataDialogListFavorites.content}
                fullScreen={false}
            />
            {
                (openDialogAddFavorites === true) && <FormSaveAliasReferenceDialogReduxForm
                    isOpenDialog={showDialogFormAddFavorites}
                    onCloseDialog={handleCloseDialogAddFavorites}
                    titleDialog={"Añadir a favoritos."}
                    onSubmit={handleSubmitAddFavorites}
                    labelField={"Alias"}
                    placeholderField={"Ejemplo: Iphone 7"}
                    nameButtonActionSave={"Guardar"}
                    nameButtonActionCancel={"Cancelar"}
                />
            }
            <DialogOTP
                openDialogOTP={OTP.openOtp}
                onCloseDialogOTP={() => setOTP({ ...OTP, openOtp: false })}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
                refreshToken={handleAcceptDialogConfirmationTransaction}

            />
            <LoadingScreen open={loading} />
        </div>
    )
}

export default connect(null, {
    createProcessMeterCode,
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser,
    getAgreementsSwitchServices
})(PaymentServiceSwitchContainer)
